import React from 'react';

import { ADMIN_DASHBOARD } from '@ApplicationWide/permissions/constants';

const BulkOnboardingPage = React.lazy(() => import('../../../pages/Admin/PendingHires/BulkOnboarding'));
const COMMON_PROPERTIES = {
  component: BulkOnboardingPage,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DASHBOARD,
  area: ADMIN_DASHBOARD,
  hasNavBar: true,
};

export default [
  {
    ...COMMON_PROPERTIES,
    route: '/administration/bulk-onboard',
  },
  {
    ...COMMON_PROPERTIES,
    route: '/administration/bulk-rehire',
    extraProps: { rehire: true },
  },
];
